import { useIsAdmin } from "@/hooks/useIsAdmin";
import { Navigate } from "react-router-dom";
import { PageLoader } from "@/components/ErrorBoundary";

/**
 * Route guard that blocks non-admin users from accessing admin pages.
 * Redirects to the dashboard if the user is not an admin.
 */
export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) return <PageLoader />;
  if (!isAdmin) return <Navigate to="/" replace />;

  return <>{children}</>;
}
